import {Customer, CustomerFactory} from "@connox/typescript-library";
import * as React from "react";

interface ICustomerContext {
  customer: Customer;
}

const customerContext = React.createContext<ICustomerContext | null>(null);

export const useCustomerContext = (): ICustomerContext => {
  const context = React.useContext(customerContext);

  if (!context) {
    throw new Error("useCustomerContext must be used in a component within a CustomerContextProvider.");
  }

  return context;
};

interface ICustomerContextProviderState {
  isLoading: boolean;
  customerContext: ICustomerContext | null;
}

const CustomerContextProvider: React.FC<{children?: React.ReactNode}> = (props) => {
  const [state, setState] = React.useState<ICustomerContextProviderState>({customerContext: null, isLoading: true});

  React.useEffect(() => {
    CustomerFactory.getCustomer().then((customer) => {
      setState({customerContext: {customer}, isLoading: false});
      customer.emitter.on(() =>
        setState({customerContext: {customer}, isLoading: false})
      );
    });
  }, []);

  if (state.isLoading || !state.customerContext) {
    return null;
  }

  const {Provider} = customerContext;

  return <Provider value={state.customerContext}>{props.children}</Provider>;
};

export default CustomerContextProvider;
